import config from "../config"

const apiServiceEndpoint = config.serverUri
const homeContentId = "65301f6e965e9b12688fd047"

// Helper function para manejar errores de respuesta HTTP de manera consistente
const handleErrorResponse = (response, errorData) => {
  // Si el servidor envió un mensaje de error, usarlo
  if (errorData && errorData.message) {
    return errorData.message
  }
  
  // Si es un 401 (Unauthorized), usar mensaje de permisos
  if (response.status === 401) {
    return "No tienes permisos para realizar esta acción"
  }
  
  // Para otros errores, usar mensaje genérico
  return "Ocurrió un error al procesar la solicitud. Por favor, intenta nuevamente."
}

const getUserMoso = partnerCode => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/socios/${partnerCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        response
          .json()
          .then(data => {
            if (data.status === 204) {
              resolve(data.message)
            }
            resolve(data)
          })
          .catch(error => {
            console.log(error)
          })
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getLegalPages = () => {
  return fetch(apiServiceEndpoint + "/legal")
}
const getHome = (token) => {
  const url = `${apiServiceEndpoint}/seccions/blocks/${homeContentId}?limit=12`

  // Construimos el objeto de headers de forma condicional
  const headers = {}
  if (token) {
    headers["x-sc-signature"] = token
  }

  return fetch(url, { headers })
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }
      return response.json()
    })
    .catch(error => {
      // Aquí puedes manejar logging o transformar el error antes de propagarlo
      throw error
    })
}


const getAllSections = () => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/seccions`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getCategories = () => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint+"/categories")
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else {
          reject(new Error("Error al obtener las categorías"))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getCategoryInfo = (categoryId) => {
  const url = apiServiceEndpoint+`/categories/${categoryId}` 

  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else {
          reject(new Error("Error al obtener la informacion de la categoría"))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getCategoryContents = (categoryId, userId = null) => {
  const url = userId 
    ? apiServiceEndpoint+`/categories/contents/${categoryId}?userId=${userId}` 
    : apiServiceEndpoint+`/categories/contents/${categoryId}`

  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else {
          reject(new Error("Error al obtener los contenidos de la categoría"))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getRecommendations = (token) => {
  // Construye la query string con los parámetros que recibas
  const params = new URLSearchParams();


  const query = params.toString() ? `?${params.toString()}` : '';
  const url = apiServiceEndpoint + `/seccions/suggest${query}`;

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'GET',
      headers: {
        "x-sc-signature": `${token}`,
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Error ${response.status} al obtener recomendaciones`);
      })
      .then(data => resolve(data))
      .catch(err => reject(err));
  });
};
const getRecomendaciones = (token) => {
  // Construye la query string con los parámetros que recibas
  const params = new URLSearchParams();


  const url = apiServiceEndpoint + `/recomendations`;

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'GET',
      headers: {
        "x-sc-signature": `${token}`,
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Error ${response.status} al obtener recomendaciones`);
      })
      .then(data => resolve(data))
      .catch(err => reject(err));
  });
};


const getOneCategoryBlock = (categoryId, userId = null, block = null) => {
  let url = apiServiceEndpoint + `/categories/contents/${categoryId}`
  if (block) {
    url += `?block=${block}`
    if (userId) {
      url += `&userId=${userId}`
    }
  } else if (userId) {
    url += `?userId=${userId}`
  }

  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          }).catch(error => reject(error))
        } else {
          reject(new Error("Error al obtener los contenidos de la categoría"))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}



const getSectionById = sectionId => {
  return new Promise((resolve, reject) => {
    fetch(
      apiServiceEndpoint + "/seccions/blocks/" + sectionId + "?limit=12"
    ).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getSectionsId = () => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/seccions`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          let seccionid = []
          data.forEach(item => seccionid.push(item.id))
          resolve(seccionid)
        })
      }
    })
  })
}

const getPathWorkout = (seccion, workout) => {
  console.log(workout)
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/cards/${seccion}`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          console.log(data)
          data.blocks.forEach(bloque => {
            bloque.cards.forEach(tarjeta => {
              if (tarjeta.entrenamiento?.id === workout) {
                resolve({
                  seccion: data.nombre,
                  tipo: tarjeta.tipoDeContenido,
                })
              }
            })
          })
        })
      }
    })
  })
}

const getBlock = (sectionId, blockId) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/" + "blocks" + "/" + blockId).then(
      response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
      }
    )
  })
}

const getBlockPage = (blockTitle, sectionId, page) => {
  return new Promise((resolve, reject) => {
    fetch(
      apiServiceEndpoint +
        "/" +
        "blocks/cards/" +
        blockTitle +
        "?limit=6&page=" +
        page
    ).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getOneBlock = blockId => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/" + "blocks/cards/" + blockId).then(
      response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
      }
    )
  })
}

const getSuggestions = (uid, sectionId) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${apiServiceEndpoint}/sugerencias/${uid}?sectionId=${sectionId}`
    ).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getAudio = id => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/audios?url_slug=${id}`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data[0])
        })
      }
    })
  })
}

const getWorkout = id => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/entrenamientos?url_slug=" + id).then(
      response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data[0])
          })
        }
      }
    )
  })
}

const getPlan = id => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/plans/${id}`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getLives = id => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/lives/${id}`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}

const getSearch = (searchTerm, sectionId) => {
  return new Promise((resolve, reject) => {
    // Construye la URL de la API con el searchTerm y sectionId
    const url = `${apiServiceEndpoint}/seccions/blocks/${sectionId}?searchTerm=${searchTerm}`

    fetch(url)
      .then(response => {
        if (response.ok) {
          response
            .json()
            .then(data => {
              // Extraer las cartas de todos los bloques
              const allCards = data.blocks.reduce((cards, block) => {
                if (block.cards) {
                  return cards.concat(block.cards)
                }
                return cards
              }, [])

              resolve(allCards)
            })
            .catch(error => {
              reject(error)
            })
        } else {
          reject("La solicitud no fue exitosa.")
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getMobilePayments = token => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments", {
      headers: {
        "x-sc-signature": `${token}`,
      },
    })
      .then(response => {
        if (response.ok) {
          // console.log("Respuesta ok")
          response.json().then(data => {
            resolve(data)
          })
        } else {
          // Intentar obtener el mensaje de error del servidor
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              // Si no se puede parsear el JSON, usar el helper
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getPaymentInfo = id => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/suscripcions`)
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            data.map(getPayment => {
              if (getPayment.id == id) resolve(getPayment)
            })
          })
        } else {
          // Intentar obtener el mensaje de error del servidor
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              // Si no se puede parsear el JSON, usar el helper
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
const getUserDetails = userid => {
  return new Promise((resolve, reject) => {
    fetch(`${apiServiceEndpoint}/users/${userid}`).then(response => {
      if (response.ok) {
        response.json().then(data => {
          resolve(data)
        })
      }
    })
  })
}
const saveNewCard = (token, card) => {
  // console.log(card)
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/methods", {
      method: "PUT",
      body: JSON.stringify(card),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          // console.log("Respuesta ok")
          // console.log(response)
          response.json().then(data => {
            resolve(data)
          })
        }

        // Manejar errores específicos de tarjetas
        if (response.status === 401 || response.status === 402) {
          console.log("Respuesta mal")
          console.log(response)
          response.json().then(error => {
            // Errores específicos de tarjetas
            if (error.message && error.message === "incorrect_number") {
              reject("Número de tarjeta incorrecto")
              return
            }

            if (error.message && error.message === "card_declined") {
              reject("Tarjeta rechazada intenta otro metódo de pago")
              return
            }

            // Usar el helper para otros errores
            reject(handleErrorResponse(response, error))
          })
          .catch(() => {
            reject(handleErrorResponse(response, null))
          })
        } else if (!response.ok) {
          // Manejar otros errores HTTP
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
        console.log("ninguna de las anteriores")
        console.log(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getDiscountedPrice = (token, code) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/getDiscountedPrice", {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json().then(data => {
            resolve(data)
          })
        } else {
          // Manejar errores
          return response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const applyCode = (token, code) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/apply/", {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.estatus === "Success") {
          resolve(data)
        } else {
          // Maneja el error según el código de error y el mensaje
          reject({
            message: data.message || "Ocurrió un error al aplicar el código",
            errorCode: data.errorCode || null,
            codigo: data.codigo || "",
          })
        }
      })
      .catch(error => {
        reject({
          message: error.message || "Error en la solicitud",
          errorCode: 9999, // Código de error genérico
        })
      })
  })
}

const checkCode = (code) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/validate-code", {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.estatus === "Success") {
          resolve(data)
        } else {
          // Maneja el error según el código de error y el mensaje
          reject({
            message: data.message || "Ocurrió un error al aplicar el código",
            errorCode: data.errorCode || null,
            codigo: data.codigo || "",
          })
        }
      })
      .catch(error => {
        reject({
          message: error.message || "Error en la solicitud",
          errorCode: 9999, // Código de error genérico
        })
      })
  })
}

const applyCodeApplePay = code => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/applyCodeApplePay", {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else {
          response.json().then(data => {
            resolve(data)
          })
        }
        if (!response.ok) {
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const deleteCard = (token, paymentMethod) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/methods/" + paymentMethod.id, {
      method: "DELETE",
      body: JSON.stringify(paymentMethod),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
        if (!response.ok) {
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const updatePaymentMethod = (token, methodId) => {
  console.log("Método de pago que se va a actualizar:", methodId);
  return fetch(`${apiServiceEndpoint}/payments/methods/${methodId}`, {
    method: 'PUT',
    headers: {
      "x-sc-signature": `${token}`,
      "Content-Type": "application/json",
    }
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        // Usar el helper para manejar errores de manera consistente
        return response.json()
          .then(errorData => {
            throw new Error(handleErrorResponse(response, errorData));
          })
          .catch(() => {
            // Si no se puede parsear el JSON, usar el helper con null
            throw new Error(handleErrorResponse(response, null));
          });
      }
    })
    .then(data => {
      // Si hay un mensaje del servidor, loguearlo pero no es necesario para el éxito
      if (data.message) {
        console.log("Mensaje del servidor:", data.message);
      }
      return data;
    })
    .catch(error => {
      console.error("Error al actualizar el método de pago en el servidor:", error);
      throw error; // Propaga el error para que `handleChange` lo capture
    });
};




const suscribe = (token, paymentMethod, ref, code) => {
  return new Promise((resolve, reject) => {
    const requestBody = {
      cardId: paymentMethod,
      suscriptionId: ref,
    }

    // Solo agrega el código si no es nulo
    if (code) {
      requestBody.code = code
    }

    fetch(apiServiceEndpoint + "/payments/suscribe", {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else if (response.status === 400) {
          response.json().then(data => {
            // Si el servidor envió un mensaje específico, usarlo
            if (data.message && data.message.message) {
              reject(data.message.message)
            } else if (data.message) {
              reject(data.message)
            } else {
              reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
            }
          })
          .catch(() => {
            reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
          })
        } else {
          // Para otros errores (incluyendo 401), usar el helper
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const paymentIntentRequest = (token, customerId, amount) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/paymentIntent", {
      method: "POST",
      body: JSON.stringify({ customerId: customerId, amount: amount }),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
        if (!response.ok) {
          if (response.status === 400) {
            response.json()
              .then(errorData => {
                // Si el servidor envió un mensaje específico, usarlo
                if (errorData && errorData.message) {
                  reject(errorData.message)
                } else {
                  reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
                }
              })
              .catch(() => {
                reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
              })
          } else {
            // Para otros errores (incluyendo 401), usar el helper
            response.json()
              .then(errorData => {
                reject(handleErrorResponse(response, errorData))
              })
              .catch(() => {
                reject(handleErrorResponse(response, null))
              })
          }
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const suscribeApplePay = (token, paymentMethod, ref, code) => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/suscribeApplePay", {
      method: "POST",
      body: JSON.stringify({ cardId: paymentMethod, suscriptionId: ref, code }),
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        } else {
          if (response.status === 400) {
            response.json()
              .then(errorData => {
                // Si el servidor envió un mensaje específico, usarlo
                if (errorData && errorData.message) {
                  reject(errorData.message)
                } else {
                  reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
                }
              })
              .catch(() => {
                reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
              })
          } else {
            // Para otros errores (incluyendo 401), usar el helper
            response.json()
              .then(errorData => {
                reject(handleErrorResponse(response, errorData))
              })
              .catch(() => {
                reject(handleErrorResponse(response, null))
              })
          }
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const unSuscribe = token => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/payments/unsuscribe", {
      method: "POST",
      headers: {
        "x-sc-signature": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
        if (!response.ok) {
          if (response.status === 400) {
            response.json()
              .then(errorData => {
                // Si el servidor envió un mensaje específico, usarlo
                if (errorData && errorData.message) {
                  reject(errorData.message)
                } else {
                  reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
                }
              })
              .catch(() => {
                reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
              })
          } else {
            // Para otros errores (incluyendo 401), usar el helper
            response.json()
              .then(errorData => {
                reject(handleErrorResponse(response, errorData))
              })
              .catch(() => {
                reject(handleErrorResponse(response, null))
              })
          }
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const uploadMedia = file => {
  return new Promise((resolve, reject) => {
    const data = new FormData()
    data.append("files", file)
    fetch(apiServiceEndpoint + `/upload`, { method: "POST", body: data })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            if (data[0].url[0] !== "/") {
              resolve(data[0].url)
            } else {
              resolve(apiServiceEndpoint + data[0].url)
            }
          })
        } else {
          reject({ code: response.status })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createUser = user => {
  return new Promise((resolve, reject) => {
    const data = new FormData()
    data.append("tecnologia", "SITIO WEB")
    data.append("email", user.email)
    data.append("username", user.email)
    data.append("password", user.password)
    data.append("firebaseId", user.firebaseId)
    if (user.avatar) data.append("avatar", user.avatar)
    data.append("alias", user.alias)
    data.append("nombre", user.firstName)
    data.append("apellido", user.lastName)
    data.append("suscription", "free")
    fetch(apiServiceEndpoint + "/users", { method: "POST", body: data })
      .then(response => {
        if (response.ok) {
          resolve()
        } else {
          reject(response.status)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createSocioUser = user => {
  return new Promise((resolve, reject) => {
    const data = new FormData()
    data.append("tecnologia", "SITIO WEB")
    data.append("email", user.email)
    data.append("username", user.email)
    data.append("password", user.password)
    data.append("firebaseId", user.firebaseId)
    if (user.avatar) data.append("avatar", user.avatar)
    data.append("alias", user.alias)
    data.append("nombre", user.firstName)
    data.append("apellido", user.lastName)
    data.append("sportCityId", user.sportCityId)
    fetch(apiServiceEndpoint + "/socios", { method: "POST", body: data })
      .then(response => {
        console.log(response)
        if (response.ok) {
          resolve()
        } else {
          reject(response.status)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createAccess = token => {
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/reportb2b-accesos", {
      method: "POST",
      headers: {
        "x-sc-signature": `${token}`,
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(res => {
            resolve(res)
          })
        }
        if (!response.ok) {
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createContentReproduced = (token, workout) => {
  const data = new FormData()
  data.append("contenidoId", workout.contenidoId)
  data.append("contenido", workout.contenido)
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/reportb2b-cont-rep", {
      method: "POST",
      body: data,
      headers: {
        "x-sc-signature": `${token}`,
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(res => {
            resolve(res)
          })
        }
        if (!response.ok) {
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
        if (response.status === 400) {
          response.json()
            .then(errorData => {
              // Si el servidor envió un mensaje específico, usarlo
              if (errorData && errorData.message) {
                reject(errorData.message)
              } else if (typeof errorData === 'string') {
                reject(errorData)
              } else {
                reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
              }
            })
            .catch(() => {
              reject("Solicitud incorrecta. Por favor, verifica los datos e intenta nuevamente.")
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createContentViews = (token, workout) => {
  const data = new FormData()
  data.append("contenidoId", workout.contenidoId)
  data.append("contenido", workout.contenido)
  data.append("tiempo", workout.tiempo)
  return new Promise((resolve, reject) => {
    fetch(apiServiceEndpoint + "/reportb2b-cont-visto", {
      method: "POST",
      body: data,
      headers: {
        "x-sc-signature": `${token}`,
      },
    })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            resolve(data)
          })
        }
        if (!response.ok) {
          response.json()
            .then(errorData => {
              reject(handleErrorResponse(response, errorData))
            })
            .catch(() => {
              reject(handleErrorResponse(response, null))
            })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export {
  getUserMoso,
  getLegalPages,
  getHome,
  getAllSections,
  getBlockPage,
  getOneBlock,
  getSectionById,
  getSectionsId,
  getPathWorkout,
  getSuggestions,
  uploadMedia,
  createUser,
  createSocioUser,
  getBlock,
  getAudio,
  getWorkout,
  getPlan,
  getLives,
  getRecommendations,
  getRecomendaciones,
  getSearch,
  getMobilePayments,
  getPaymentInfo,
  checkCode,
  applyCode,
  applyCodeApplePay,
  saveNewCard,
  deleteCard,
  suscribe,
  unSuscribe,
  getUserDetails,
  paymentIntentRequest,
  suscribeApplePay,
  createAccess,
  createContentReproduced,
  createContentViews,
  getDiscountedPrice,
  updatePaymentMethod,
  getCategories,
  getCategoryContents,
  getCategoryInfo,
  getOneCategoryBlock
}
